

export function saveOr(taskId:number, inputId:number, input:HTMLElement){

    const options = $(input).find(".order-option");
    const order = [];

    // Loop through all options
    options.each((ind, obj) => {

        const answerId = Number($(obj).attr('data-id'));
        order.push(answerId)
        
    })

    return {answer: order};

}